export default __webpack_public_path__ + "static/media/login-bg.47d5435d.png";